import React, { useEffect, useState } from "react";
import LeadCard from "./components/LeadCard";
import { toast } from "react-toastify";
import axios from "common/configs/axiosConfigs";
import Select from "common/components/Select";
import { LEAD_STATUS_OPTIONS } from "common/constants/enums";

const Leads = () => {
  const companyId = JSON.parse(localStorage.getItem("user-auth"))?.company_id;
  const [leads, setLeads] = useState([]);
  const [leadStatus, setLeadStatus] = useState("All");
  const [filter, setFilter] = useState({ searchDate: "" });
  const handleLeadStatusChange = ({ target: { value } }) => {
    setLeadStatus(value);
  };

  const getLeads = async () => {
    try {
      const { data } = await axios.post("", {
        action: "getLead",
        leadStatus,
        companyId,
        searchDate: filter.searchDate,
      });
      if (data.success) {
        setLeads(data?.data);
      } else {
        toast.error(data?.message);
      }
    } catch (err) {
      console.error("ERROR:", err);
    }
  };
  useEffect(() => {
    getLeads();
  }, [leadStatus, filter]);
  const handleFilter = ({ target: { name, value } }) => {
    setFilter((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <section>
      <div className="row align-items-center mb-3 ">
        <h4 className="page-title">Leads</h4>
        <input
          type="date"
          name="searchDate"
          onChange={handleFilter}
          className="ms-auto form-control"
        />
        <div className="ms-0 searchbar-cover">
          <Select
            options={LEAD_STATUS_OPTIONS}
            value={leadStatus}
            className="form-control"
            name="leadStatus"
            onChange={handleLeadStatusChange}
          />
        </div>
      </div>
      <div className="row gy-4">
        {leads?.map((c) => (
          <div className=" col-lg-6">
            <LeadCard {...{ c, getLeads }} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Leads;
